const getters = {
  hasLogin: state => state.user.hasLogin,
  username: state => state.user.username,
  role: state => state.user.role,
  mdValue: state => state.markdown.mdValue,
  mdHtml: state => state.markdown.mdHtml,
  md_product_desc: state => state.markdown.md_product_desc,
  html_product_desc: state => state.markdown.html_product_desc,
  md_product_intro: state => state.markdown.md_product_intro,
  html_product_intro: state => state.markdown.html_product_intro,
  md_product_params: state => state.markdown.md_product_params,
  html_product_params: state => state.markdown.html_product_params
}

export default getters
